import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {Card, Chip} from "@mui/material";
import Meta from "../common/Meta";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import Grid from "@mui/material/Grid";
import {archiveCompanyMatrix, getCompanyMatrixes} from "../common/api/WebApi";
import MDButton from "../../components/MDButton";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import PageLoading from "../common/PageLoading";
import * as pagination from "../common/pagination";
import {displayAgeRange, formatCurrency} from "../common/Utils";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import Confirm from "../common/Confirm";
import ManageEventMatrixModal from "../matrix/ManageEventMatrixModal";
import Audit from "../common/Audit";


export default function EventMatrix(props) {

  const [isNew, setIsNew] = useState(true);
  const [loading, setLoading] = useState(true);
  const [context, setContext] = useContext(AppContext);

  const [isManagingMatrix, setIsManagingMatrix] = useState(false);

  const [matrix, setMatrix] = useState(null);

  const manageMatrix = (item) => {
    setIsManagingMatrix(true);
    setMatrix(item);
  }

  const [eventMatrixes, setEventMatrixes] = useState([]);

  const [render, setRender] = useState(0);
  const [startPage, setStartPage] = useState(0);
  const [templates, setTemplates] = useState([]);
  const [sortOrder, setSortOrder] = useState(1);
  const [sortDir, setSortDir] = useState('asc');
  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);
  const [searchCriteria, setSearchCriteria] = useState();

  useEffect(() => {
    getMatrixes();
  }, []);

  const getMatrixes = async () => {
    setLoading(true);
    getCompanyMatrixes().then(result => {
      setLoading(false);
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEventMatrixes(result);
      }
    });
  }

  const [confirmation, setConfirmation] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [archiveCode, setArchiveCode] = useState(false);

  const [saving, setSaving] = useState(false);
  const deleteDiscountCode = () => {
    setLoading(true);
    setSaving(true);
    archiveCompanyMatrix(matrix).then(result => {
      setSaving(false);
      setLoading(false);
      setMatrix(null);
      setArchiveCode(false);
      setConfirmation(null);
      setShowConfirm(false);

      getMatrixes();
    });
  }

  const preDeleteCode = (item) => {
    let confirmation = {
      title: 'Archive Matrix?',
      message: 'Archive ' + item.name + '?',
      entity: item
    }
    setConfirmation(confirmation);
    setShowConfirm(true);
    setMatrix(item);
  };

  const Actions = ({item}) => {

    return (<PopupState variant="popover" popupId={'matrix-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
            <MDButton
              variant="outlined"
              color="secondary"
              size="small"
              circular
              iconOnly
            >
              <Icon>more_horiz</Icon>
            </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageMatrix(item);
              }} icon={<Icon>edit</Icon>} title="Edit"/>

            <NotificationItem onClick={(e) => {
              popupState.close();
              preDeleteCode(item);
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  return (
    <>
      <DashboardLayout>
        <Meta pageTitle={'Company Event Pricing Matrix'}/>
        <ContextSearchNavbar title="Company Event Pricing Matrix"/>

        <MDBox mt={4}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <MDBox pb={3}>
                <MDBox mb={3}>
                  <Card>
                    <MDBox p={3} lineHeight={1}>

                      <MDButton
                        onClick={() => {
                          manageMatrix(null);
                        }}
                        color="info"
                        size="small"
                        className="pull-right"
                        variant="contained">New Matrix</MDButton>

                      <h5 fontWeight="regular">
                        Event Pricing Matrix
                      </h5>

                      <Grid container mt={2} spacing={2}>
                        {eventMatrixes?.sort((a, b) => a.name.localeCompare(b.name))?.map((matrix, idx) => {
                          return (
                            <Grid item xs={12} sm={6} key={idx}>
                              <div className={' psb-bordered '}>
                                <>
                                  <h6>
                                    <a href={"#"} onClick={(e) => {
                                      e.preventDefault();
                                      manageMatrix(matrix);
                                    }}>
                                      {matrix.name}
                                    </a>
                                    <span className={'pull-right'}>
                                      <Actions item={matrix}/>
                                    </span>
                                  </h6>
                                  {matrix?.description && <p>{matrix.description}</p>}

                                  {(matrix?.requireAdultAttendee || matrix?.requireChildAttendee) &&
                                    <span style={{
                                      display:'block',
                                      margin:'4px 0 8px 0'
                                    }}>
                                      {matrix?.requireAdultAttendee && <>
                                        <Chip className={'mt-1'}
                                              label={'Adult Required'}
                                              icon={<Icon>person</Icon>}
                                              color="primary"
                                              variant="outlined"
                                              size="medium"
                                        />&nbsp;
                                      </>}
                                      {matrix?.requireChildAttendee && <>
                                        <Chip className={'mt-1'}
                                              label={'Child Required'}
                                              icon={<Icon>person</Icon>}
                                              color="primary"
                                              variant="outlined"
                                              size="medium"
                                        />&nbsp;
                                      </>}
                                    </span>
                                  }

                                  <Audit auditCreateUser={matrix} auditModifyUser={matrix}/>
                                  {matrix?.entries?.length > 0 && <div>
                                    <h6>Entries</h6>
                                    <div>
                                      {matrix.entries?.sort((a, b) => a.id - b.id).map((entry, idx) => {
                                        return (
                                          <span key={idx}>
                                              <Chip className={'mt-1'}
                                                    label={(formatCurrency(entry.price)) + ' ' + (entry?.adult ? 'Adult' : displayAgeRange(entry))}
                                                    icon={<Icon>person</Icon>}
                                                    color="primary"
                                                    variant="outlined"
                                                    size="medium"
                                              />&nbsp;
                                          </span>
                                        )
                                      })}

                                    </div>
                                  </div>
                                  }
                                </>
                              </div>

                            </Grid>
                          )
                        })}
                      </Grid>


                    </MDBox>

                  </Card>
                </MDBox>

                {loading && <PageLoading/>}

              </MDBox>
            </Grid>
          </Grid>
        </MDBox>


        <Footer mt={5}/>

      </DashboardLayout>

      {
        confirmation && <Confirm confirmation={confirmation}
                                 show={showConfirm}
                                 saving={saving}
                                 handleSave={() => {
                                   setShowConfirm(false);
                                 }}
                                 handleConfirm={deleteDiscountCode}
                                 handleClose={() => {
                                   setConfirmation(null);
                                   setShowConfirm(false);
                                 }}/>
      }


      {isManagingMatrix && <ManageEventMatrixModal
        handleSave={(data) => {
          setMatrix(null);
          setIsManagingMatrix(false);
          getMatrixes();
        }}
        show={isManagingMatrix} matrix={matrix} handleClose={() => {
        setIsManagingMatrix(false);
        setMatrix(null);
      }}/>}
    </>
  );
}